<div class="w-[100vw] h-[70vh]">
  <div>
    <object class="w-[100vw] h-[70vh]" [data]="getPdfFile()|safeResourceString" type="application/pdf"></object>
  </div>
</div>
<!--<pdf-viewer [src]="getPdfFile()" [render-text]="false"-->
<!--            [original-size]="false"-->
<!--            style="width: 100vw; height: 60vh"></pdf-viewer>-->
